import React, { useEffect } from 'react';
import { createStructuredSelector } from 'reselect';
import { useHistory } from 'react-router';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { SideBar } from '../../components/sidebar';
import { Header } from '../../components/header';
import { Layout } from './components/layout';
import { Content } from './components/content';
import { Container } from './components/container';
import ProfileModal from '../profile';
import { NO_AUTH_PAGES, PAGE_LINKS } from './constants';
import RightHeaderContent from '../right-header-content';
import { getLocalStorageItem, setLocalStorageItem } from '../../utils/localStorage';
import { ContentRouter } from '../../components/content-router';
import TrailersModal from '../trailers-modal';
import DetailModal from '../details-modal';
import CarsModal from '../cars-modal';
import AddressModal from '../address-modal';
import ContactModal from '../contact-modal';
import PeriodsDictionaryModal from '../dictionaries/periods';
import CompaniesTypesDictionaryModal from '../dictionaries/companies-types';
import TypesDictionaryModal from '../dictionaries/types';
import ModesDictionaryModal from '../dictionaries/modes';
import StatusesDictionaryModal from '../dictionaries/statuses';
import CompaniesModal from '../dictionaries/companies-modal';
import WaysModal from '../ways-modal';
import PartnerModal from '../partner-modal';
import LegalModal from '../legal-modal';
import UsersRolesModal from '../users-roles-modal';
import UsersModal from '../users-modal';
import { useInjectReducer } from '../../utils/injectReducer';
import reducer from '../profile/reducer';
import { getUserInfoAction, setUserRulesAction } from '../profile/actions';
import CarrierChangeModal from '../carrier-change-modal';
import DateCargoCollectionModal from '../date-cargo-collection-modal';
import RequestModal from '../request-modal';
import ReqsDetailsModal from '../reqs-details-modal';
import ClaimsDetailsModal from '../claims-details-modal';
import DriverChangeModal from '../driver-change-modal';
import { AlertModal } from '../alert-modal';
import CarChangeModal from '../car-change-modal';
import RefusalReasonModal from '../refusal-reason-modal';
import FeaturesDictionaryModal from '../dictionaries/features';
import DocumentAttachmentForm from '../document-attachment-form';
import CargoDeliveryModal from '../cargo-delivery-modal';
import { HeaderSearch } from '../header-search';
import TonnagesDictionaryModal from '../dictionaries/tonnages';
import RatesDictionaryModal from '../dictionaries/rates';
import SpecifyFlightModal from '../specify-flight-modal';
import {
	getIsAcceptedTermsSelector,
	getIsCompanyAccreditationSelector,
	getIsCompanyAccreditedSelector,
	getIsCompanyValidateSelector,
	getIsEmailVerifySelector,
} from './selectors';
import DeliveryStatusesDictionaryModal from '../dictionaries/delivery-statuses';
import ProductInvoiceModal from '../product-invoice-modal';
import { setWindowInfoAction } from '../alert-modal/actions';
import ChosenCommentModal from '../chosen-comment-modal';
import NoteModal from '../note-modal';
import ApproveCarrierModal from '../approve-carrier-modal';
import RelationshipModal from '../relationship-modal';
import OrdersWaysModal from '../orders-ways-modal';
import ClaimsSolutionForm from '../claims-details-modal/components/claims-solution-form';
import ClaimsRejectForm from '../claims-details-modal/components/claims-reject-form';
import ClaimsDocumentsForm from '../claims-details-modal/components/claims-documents-form';
import { ClaimForm } from '../reqs-details-modal/components/claim-form';
import CustomUidModal from '../custom-uid-modal';
import SelectAccreditationModal from '../select-accreditation-modal';
import CostModal from '../cost-modal';
import RelationshipSettingsModal from '../relationship-settings-modal';
import OrderGroupsModal from '../orders-groups-modal';
import OrdersModal from '../orders-modal';
import OrderImportFormContainer from '../orders-imports-modal';
import CargoExpressDeliveryModal from '../cargo-express-delivery-modal';
import CargoFetchModal from '../cargo-fetch-modal/index';
import CargoPickupModal from '../cargo-pickup-modal';
import { PlanningsProcessContainer } from '../orders-plannings-process';
import AutoparkModal from '../autoparks-modal';
import AutoparkTransportModal from '../autoparks-transports-modal';
import IcepackModal from '../icepacks-modal';
import IcepackFillerModal from '../icepacks-fillers-modal';
import IcepackStateModal from '../icepacks-states-modal';
import IcepackFilledModal from '../icepacks-filled-modal';
import ThermoboxModal from '../thermoboxes-modal';
import ThermoboxReportModal from '../thermoboxes-reports-modal';
import ThermoboxReportDocumentsForm from '../thermoboxes-reports-modal/components/thermobox-report-documents-form';

export const MainWrapper = ({
	onSetUserRules,
	onGetUserInfo,
	isEmailVerify,
	isCompanyAccredited,
	isAcceptedTerms,
	onSetWindowInfo,
	isCompanyAccreditation,
}) => {
	useInjectReducer({ key: 'profileModalReducer', reducer });

	const history = useHistory();

	const isProtectedRouts = isEmailVerify && isCompanyAccredited && isAcceptedTerms && isCompanyAccreditation;

	useEffect(() => {
		const token = getLocalStorageItem('user');

		const rules = getLocalStorageItem('rules');

		const isNotAuthPage =
			history.location.pathname.includes('/password/reset') || NO_AUTH_PAGES.includes(history.location.pathname);

		if ((!token || !rules) && !isNotAuthPage) {
			setLocalStorageItem('last_url', window.location.href);
			history.push('/login');
		}
		if (rules) {
			onSetUserRules(rules);
			onGetUserInfo(history);
		}
	}, []);

	useEffect(() => {
		const pathname = history.location.pathname;

		const isNotAuthPage = pathname.includes('/password/reset') || NO_AUTH_PAGES.includes(pathname);

		const isEmailVerifyPage = pathname.includes('/email/verify');

		const isAcceptedTermsPage = pathname.includes('/accept-terms');

		const isCompanyAccreditationPage = pathname.includes('/company-accreditation');

		const isCompanyVerifyPage = pathname.includes('/company/accredited');

		if (!isEmailVerify && !isNotAuthPage && !isEmailVerifyPage) {
			history.push('/email/verify');
			return;
		}

		if (isEmailVerify && !isAcceptedTerms && !isNotAuthPage && !isAcceptedTermsPage) {
			history.push('/accept-terms');
			return;
		}

		if (
			isEmailVerify &&
			isAcceptedTerms &&
			!isCompanyAccreditation &&
			!isNotAuthPage &&
			!isCompanyAccreditationPage
		) {
			history.push('/company-accreditation');
			return;
		}

		if (
			isEmailVerify &&
			isAcceptedTerms &&
			isCompanyAccreditation &&
			!isCompanyAccredited &&
			!isNotAuthPage &&
			!isCompanyVerifyPage
		) {
			history.push('/company/accredited');
		}
	}, [isEmailVerify, isAcceptedTerms, isCompanyAccreditation, isCompanyAccredited]);

	const handleAlertModalOpen = () => {
		onSetWindowInfo({ type: 'forbidden', title: 'Внимание', text: 'Раздел находится в разработке' });
	};

	return (
		<>
			<ProfileModal />
			<CompaniesModal />
			<AlertModal />
			<Layout>
				<SideBar />
				<Content>
					<Header
						searchInput={<HeaderSearch />}
						links={PAGE_LINKS}
						rightSideContent={<RightHeaderContent />}
						onAlertModalOpen={handleAlertModalOpen}
					/>
					<Container>
						<ContentRouter isProtectedRouts={isProtectedRouts} />
					</Container>
				</Content>
			</Layout>
			{isProtectedRouts && (
				<>
					<AutoparkModal />
					<AutoparkTransportModal />
					<ThermoboxModal />
					<ThermoboxReportModal />
					<ThermoboxReportDocumentsForm />
					<IcepackModal />
					<IcepackFillerModal />
					<IcepackStateModal />
					<IcepackFilledModal />
					<TrailersModal />
					<DetailModal />
					<CargoPickupModal />
					<CargoFetchModal />
					<CargoDeliveryModal />
					<CargoExpressDeliveryModal />
					<SpecifyFlightModal />
					<CarsModal />
					<AddressModal />
					<ContactModal />
					<PeriodsDictionaryModal />
					<CompaniesTypesDictionaryModal />
					<DeliveryStatusesDictionaryModal />
					<TypesDictionaryModal />
					<FeaturesDictionaryModal />
					<ModesDictionaryModal />
					<RatesDictionaryModal />
					<TonnagesDictionaryModal />
					<StatusesDictionaryModal />
					<WaysModal />
					<PartnerModal />
					<LegalModal />
					<UsersRolesModal />
					<UsersModal />
					<CarrierChangeModal />
					<DateCargoCollectionModal />
					<DriverChangeModal />
					<RequestModal />
					<ReqsDetailsModal />
					<CarChangeModal />
					<RefusalReasonModal />
					<DocumentAttachmentForm />
					<ProductInvoiceModal />
					<CustomUidModal />
					<ChosenCommentModal />
					<NoteModal />
					<ApproveCarrierModal />
					<RelationshipModal />
					<OrdersWaysModal />
					<ClaimsDetailsModal />
					<ClaimsSolutionForm />
					<ClaimsRejectForm />
					<ClaimsDocumentsForm />
					<ClaimForm />
					<SelectAccreditationModal />
					<CostModal />
					<RelationshipSettingsModal />
					<OrderGroupsModal />
					<OrdersModal />
					<OrderImportFormContainer />
					<PlanningsProcessContainer />
				</>
			)}
		</>
	);
};

const mapStateToProps = createStructuredSelector({
	isCompanyValidate: getIsCompanyValidateSelector(),
	isCompanyAccredited: getIsCompanyAccreditedSelector(),
	isEmailVerify: getIsEmailVerifySelector(),
	isAcceptedTerms: getIsAcceptedTermsSelector(),
	isCompanyAccreditation: getIsCompanyAccreditationSelector(),
});

const mapDispatchToProps = {
	onSetUserRules: setUserRulesAction,
	onGetUserInfo: getUserInfoAction,
	onSetWindowInfo: setWindowInfoAction,
};

const Main = connect(mapStateToProps, mapDispatchToProps)(MainWrapper);

MainWrapper.propTypes = {
	onSetUserRules: PropTypes.func.isRequired,
	onGetUserInfo: PropTypes.func.isRequired,
	isEmailVerify: PropTypes.bool.isRequired,
	isCompanyValidate: PropTypes.bool.isRequired,
	isCompanyAccredited: PropTypes.bool.isRequired,
	isAcceptedTerms: PropTypes.bool.isRequired,
	isCompanyAccreditation: PropTypes.bool.isRequired,
	onSetWindowInfo: PropTypes.func.isRequired,
};

export { Main };
